import React, { useEffect } from 'react';
import { ShieldCheck, X } from 'lucide-react';

export function PrivacyPolicyModal({ isOpen, onClose }) {
  // Keyboard Escape Key Trap & Focus Management
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-md overflow-y-auto" role="dialog" aria-modal="true" aria-labelledby="privacy-modal-title">
      <div className="relative w-full max-w-2xl my-8 rounded-2xl border border-slate-200 bg-white text-slate-900 shadow-2xl dark:border-slate-800 dark:bg-slate-900 dark:text-slate-100 p-6 sm:p-8 space-y-6">
        <div className="flex items-center justify-between border-b border-slate-200 dark:border-slate-800 pb-4">
          <div className="flex items-center gap-2">
            <ShieldCheck className="h-5 w-5 text-amber-500" />
            <h3 id="privacy-modal-title" className="text-xl font-bold text-slate-900 dark:text-white">Privacy Policy & SMS Terms</h3>
          </div>
          <button onClick={onClose} aria-label="Close Privacy Modal" className="rounded-lg p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-900 dark:hover:bg-slate-800 dark:hover:text-white transition cursor-pointer">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-4 text-xs sm:text-sm text-slate-700 dark:text-slate-300 leading-relaxed max-h-[60vh] overflow-y-auto pr-2">
          <h4 className="font-bold text-slate-900 dark:text-white text-base">1. Information We Collect</h4>
          <p>
            When you request a strategy session or complete the academic diagnostic quiz on GradeLynk, we collect student/parent name, email, phone number, and grade level.
          </p>

          <h4 className="font-bold text-slate-900 dark:text-white text-base">2. How We Use Information</h4>
          <p>
            We use your phone number and email strictly to schedule your 15-minute 1-on-1 strategy call with Kian and send diagnostic recommendations. We do NOT sell or share data with 3rd-party advertisers.
          </p>

          <h4 className="font-bold text-slate-900 dark:text-white text-base">3. Missed-Call & SMS Notification Terms</h4>
          <p>
            By opting into our notification terms, you consent to receive direct telephone calls or SMS messages from Kian Ahadi (+1 437 438-2820) regarding your strategy session appointment.
          </p>
        </div>

        <div className="pt-4 border-t border-slate-200 dark:border-slate-800 text-right">
          <button onClick={onClose} className="px-6 py-2.5 rounded-xl bg-amber-500 hover:bg-amber-400 text-slate-950 font-bold text-sm cursor-pointer">
            Close & Accept Terms
          </button>
        </div>
      </div>
    </div>
  );
}
